export enum MinificationTextureFilter {
  Nearest = 1003,
  NearestMipmapNearest = 1004,
  NearestMipmapLinear = 1005,
  Linear = 1006,
  LinearMipmapNearest = 1007,
  LinearMipmapLinear = 1008
}
export const MinificationTextureFilterDescriptions: Record<MinificationTextureFilter, string> = {
  [MinificationTextureFilter.Nearest]: "",
  [MinificationTextureFilter.NearestMipmapNearest]: "",
  [MinificationTextureFilter.NearestMipmapLinear]: "",
  [MinificationTextureFilter.Linear]: "",
  [MinificationTextureFilter.LinearMipmapNearest]: "",
  [MinificationTextureFilter.LinearMipmapLinear]: "",
}
